var AppState = require('app_state');
var Consts = require('consts');
var Misc = require('utils/misc');

var objectRegister = {};

var getValueMoment = function (value) {
    var m = moment.utc(value, 'DD.MM.YYYY HH:mm');
    if (!m.isValid()) {
        m = moment();
    }
    return m.local();
};

var saveValueOf = function (fvid, value) {
    var ctx = objectRegister[fvid];
    if (!ctx) return;
    ctx.ownerObject[ctx.key] = value;
};

var saveValue = function (e, value) {
    var fvid = $(e.currentTarget).data('fvid');
    saveValueOf(fvid, value);
};

var saveDateTime = function (e) {
    var $row = $(e.currentTarget).closest('div.row');
    var datePart = $row.find('.js-datepicker').val();
    var timePart = $row.find('.js-timepicker').val();
    var resultDateTime = datePart + ' ' + timePart;

    var m = moment(resultDateTime, 'DD.MM.YYYY HH:mm');
    if (m.isValid()) {
        resultDateTime = m.utc().format('DD.MM.YYYY HH:mm');
        saveValueOf($row.find('.js-datepicker').data('fvid'), resultDateTime);
    }
};

var idCounter = 1;

module.exports = {
    getTemplateData: function (fieldName, ownerObject, key, fieldValuesEnum, fvid, size) {
        var fieldInfo = AppState.availableColumnData(fieldName) || {
            field_type:
                fieldName.split('_').length == 2 && parseInt(fieldName.split('_')[1]) > 0
                    ? Consts.FieldGroup.Data
                    : undefined,
        };

        var value = ownerObject && ownerObject[key];
        var isFieldData = fieldInfo.field_type == Consts.FieldGroup.Data;
        var isFixedDate = Consts.FieldInfo.Date.indexOf(fieldName) != -1;
        var fieldValueInfo = isFieldData && (AppState.availableColumnData(value) || {});
        var isEnum =
            fieldInfo &&
            fieldInfo.format &&
            (fieldInfo.format.substr(0, 2) == 'r{' || fieldInfo.format.indexOf('/') > 0);
        var unit = undefined;
        var isFixedTextSelect = fieldValuesEnum && fieldValuesEnum[fieldName] && fieldValuesEnum[fieldName].length > 0;

        if (isFieldData && !isEnum) {
            var valueInfo = Misc.formatValueUnitBySpec(value || 0, fieldName, fieldInfo, true);
            unit = valueInfo.unit;
            value = valueInfo.value;
        }

        idCounter++;

        var templateData = {
            fieldInfo: fieldInfo,
            ownerObject: ownerObject,
            key: key,
            isFieldData: isFieldData,
            isFixedDate: isFixedDate,
            isFixedText: !isFixedDate && !isFieldData,
            isFieldDataRef: fieldValueInfo.field_type == Consts.FieldGroup.Data,
            isFieldDataTypeEnum: isEnum,
            isFixedTextSelect: isFixedTextSelect,
            fieldTextSelectOptions: isFixedTextSelect && fieldValuesEnum[fieldName],
            isFixedNumeric: Consts.FieldInfo.Numeric.indexOf(fieldName) != -1,
            fieldDataEnumItems: isEnum && Misc.getEnumItems(fieldInfo.format),
            valueDate: isFixedDate && getValueMoment(value).format('DD.MM.YYYY'),
            valueTime: isFixedDate && getValueMoment(value).format('HH:mm'),
            value: value,
            valueUnit: fieldInfo.unit,
            fvid: fvid || idCounter,
            size: size,
        };

        objectRegister[fvid] = templateData;

        return templateData;
    },

    attachEvents: function () {
        $('.js-fv-tb-1').on('keyup', function (e) {
            saveValue(e, $(e.currentTarget).val());
        });
        $('select.js-fv-sel-1').on('change', function (e) {
            saveValue(e, $(e.currentTarget).val());
        });
        $('.js-fv-tb-2').on('change', function (e) {
            saveDateTime(e);
        });
        $('.js-fv-tb-2').on('keyup', function (e) {
            saveDateTime(e);
        });
        $('.js-fv-tb-3').on('keyup', function (e) {
            var fvid = $(e.currentTarget).data('fvid');
            var ctx = objectRegister[fvid];
            if (!ctx) return;

            value = $(e.currentTarget).val();
            value = parseFloat(value);
            var valueSpec = ctx.fieldInfo;
            value = Misc.getRawValue(value, valueSpec.id.substr(0, 3), valueSpec.format);
            ctx.ownerObject[ctx.key] = value;
        });
    },
};
